//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

import { ActionTypes } from 'store/constants';
import { map, filter } from 'lodash';

//  ----------------------------------------------------------------------------
//  Reducer
//  ----------------------------------------------------------------------------

const galleryInitial = {
    data: [],
    total: 1,
};

export const image_gallery = (state = galleryInitial, action) => {
    switch (action.type) {
        case ActionTypes.image_gallery.create_image_gallery:
            return {
                ...state,
                data: [action.payload, ...state.data],
                total: state.total + 1,
            };

        case ActionTypes.image_gallery.list_image_gallery:
            return {
                ...state,
                data: action.payload.data || [],
                total: action.payload.total || 0,
            };

        case ActionTypes.image_gallery.update_image_gallery:
            return {
                ...state,
                data: map(state.data, (dt) =>
                    dt.id === action.payload.id ? action.payload : dt
                ),
            };

        case ActionTypes.image_gallery.delete_image_gallery:
            const idsToDelete = action.payload.map((item) => item.id);
            return {
                ...state,
                data: filter(state.data, (dt) => !idsToDelete.includes(dt.id)),
                total: Math.max(state.total - idsToDelete.length, 0),
            };

        default:
            return state;
    }
};